var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKeyColored(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A9531F7C-0C91-4867-988F-2E4F4AE73D51") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-KIt",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-206.000000, -280.000000)",
    fill: "#8B88FF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.962969,280 C214.177794,280 211.925937,282.251852 211.925937,285.037022 C211.925937,285.629614 212.044456,286.222207 212.222219,286.814799 L206,293.037037 L206,296 L208.962969,296 L208.962969,294.222222 L210.74075,294.222222 L210.74075,292.444444 L212.518531,292.444444 L215.185187,289.777793 C215.718537,289.955556 216.311131,290.074074 216.962969,290.074074 C219.748175,290.074074 222,287.822222 222,285.037053 C222,282.251883 219.748175,280 216.962969,280 Z M218.444469,285.333333 C217.437044,285.333333 216.666687,284.562978 216.666687,283.555556 C216.666687,282.548133 217.437044,281.777778 218.444469,281.777778 C219.451893,281.777778 220.22225,282.548133 220.22225,283.555556 C220.22225,284.562978 219.451893,285.333333 218.444469,285.333333 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyColored);
export default ForwardRef;